import { EnvironmentInterface } from './environment.interface';
import { NgxLoggerLevel } from 'ngx-logger';

const environment: EnvironmentInterface = {
  production: true,
  envName: 'prod',
  serviceWorker: true,
  chat: {
    serviceUrl: 'http://hechat.us-east-1.elasticbeanstalk.com',
  },
  app: {
    baseUrl: 'https://mobile-api-production.hoteleffectiveness.com/',
    domain: 'mobile-api-production.hoteleffectiveness.com',
    api: 'api/',
    heEventLogApi: 'https://events.hoteleffectiveness.com/api/v1/heEventLog',
    perfectEngage: {
      learnMoreUrl:
        'https://he-static-assets.s3.amazonaws.com/prod/mobile/perfect_engage/learn_more.html',
    },
  },
  google: {
    recaptcha: {
      sitekey: '6LcjHGUUAAAAAEYtP1EaX_NQj6odeycIU4V9eiq4',
    },
    analytics: {
      trackingId: 'UA-3930354-6',
    },
  },
  aws: {
    cognito: {
      keyUrl:
        'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_Ss8gGPnxq/.well-known/jwks.json',
      iss: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_Ss8gGPnxq',
      alg: ['RS256'],
    },
  },
  logConfig: {
    level: NgxLoggerLevel.LOG,
  },
};

export { environment, EnvironmentInterface };
